/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  DeleteConfigRequestBody,
  DeleteConfigRequestBody$Outbound,
  DeleteConfigRequestBody$outboundSchema,
} from "../components/deleteconfigrequestbody.js";

export type DeleteAIIntegrationConfigSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type DeleteAIIntegrationConfigRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  deleteConfigRequestBody: DeleteConfigRequestBody;
};

/** @internal */
export type DeleteAIIntegrationConfigSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteAIIntegrationConfigSecurity$outboundSchema: z.ZodMiniType<
  DeleteAIIntegrationConfigSecurity$Outbound,
  DeleteAIIntegrationConfigSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function deleteAIIntegrationConfigSecurityToJSON(
  deleteAIIntegrationConfigSecurity: DeleteAIIntegrationConfigSecurity,
): string {
  return JSON.stringify(
    DeleteAIIntegrationConfigSecurity$outboundSchema.parse(
      deleteAIIntegrationConfigSecurity,
    ),
  );
}

/** @internal */
export type DeleteAIIntegrationConfigRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  DeleteConfigRequestBody: DeleteConfigRequestBody$Outbound;
};

/** @internal */
export const DeleteAIIntegrationConfigRequest$outboundSchema: z.ZodMiniType<
  DeleteAIIntegrationConfigRequest$Outbound,
  DeleteAIIntegrationConfigRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    deleteConfigRequestBody: DeleteConfigRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      deleteConfigRequestBody: "DeleteConfigRequestBody",
    });
  }),
);

export function deleteAIIntegrationConfigRequestToJSON(
  deleteAIIntegrationConfigRequest: DeleteAIIntegrationConfigRequest,
): string {
  return JSON.stringify(
    DeleteAIIntegrationConfigRequest$outboundSchema.parse(
      deleteAIIntegrationConfigRequest,
    ),
  );
}
